import { createStore } from "vuex";
import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

const store = createStore({
  modules: {},
  state() {
    return {
      appVersion: null,
      apiUrl: "",

      configHasBeenRead: false,
      config: null,
      memberExists: false,

      questions: [],
      playerLevels: [],
      rankings: [],
      playerMoments: [],

      registered: false,
    };
  },

  mutations,
  actions,
  getters,
});

export default store;
